<template>
	<div class="body">

		<div style="width: 100%; padding-top:20px">
			<table class="table" v-loading="loading2">
				<thead>
					<tr>
						<th></th>
						<th>项目名称</th>
						<th>教室</th>
						<th>创建时间</th>
						<th>操作</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td></td>
						<td>
							<div class="buts" @click="dialogVisible0=true">新建项目</div>
						</td>
					</tr>
					<tr v-for="(item,index) in tabledate" :key="index">
						<td>{{index+1}}</td>
						<td>{{item.name}}</td>
						<td  style="max-width: 250px;">
							<div class="jiaoshu">
								<ul>
									<li v-for="(c,inx) in item.class_room">
										{{c.content}}
										<i @click="tan(index)" class="el-icon-circle-plus-outline" v-if="inx==0"></i>
										<i @click="jiao_del(c.id)" class="el-icon-remove-outline" v-if="inx>0"></i>
									</li>
								</ul>
							</div>
							<div style="clear:both"></div>
							<div class="tjia" v-show="tanindex==index+1">
								<input v-model="inss" />
								<button @click="tan_buts(item.id)">确定</button>
							</div>
						</td>
						<td>{{item.create_time}}</td>
						<td class="operation">
							<el-button @click="jump('xinjianhetong',item.id)" plain size="mini">{{item.check==1 ? '新建合约' : '查看合约'}}</el-button>
							<span style="padding-left: 50px;"></span>
							<el-button @click="san_del(item.id,item.name)" size="mini" type="danger">删除</el-button>
						</td>
					</tr>
				</tbody>
			</table>
			<p>共{{skjlnum}}条数据，当前第{{curpage}}页</p>
			<div class="table-bottom">
				<div>
					<el-pagination @current-change="fanye" :page-size="pageone" background :total="skjlnum" :current-page="curpage"
					 layout="prev, pager, next">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 新建项目 -->
		<el-dialog class="tanchuang" :visible.sync="dialogVisible0" mixwidth="400px" center>
			<span slot="title" class="dialog-footer">新建项目</span>
			<div class="task_box1">
				<label>项目名称</label>
				<input v-model="input0" />
			</div>
			<div class="task_box2">
				<span style="color: red;">*</span>
				说明:新建项目可添加该项目专属合约。
			</div>
		     <span slot="footer">
				<el-button style="background:#8CBB77;border: 0;" type="success" @click="xin_but()" round>确 定</el-button>
				<span style="padding-left: 50px;"></span>
				<el-button style="color:#8CBB77;border: 1px solid #8CBB77;" @click="dialogVisible0 = false" round>取 消</el-button>
			  </span>
		</el-dialog>

		<!-- 删除项目 -->
		<el-dialog class="tanchuang" :visible.sync="dialogVisible1" width="22%" center>
			<span slot="title" class="dialog-footer">温馨提示</span>
			<div class="task_box1">
				<i class="el-icon-warning" style="color: red;"></i>
				确定要删除该{{item_name}}项目吗？
			</div>
		     <span slot="footer">
				<el-button style="background:#8CBB77;border: 0;" type="success" @click="project_del()" size="mini" round>确 定</el-button>
				<span style="padding-left: 50px;"></span>
				<el-button style="color:#8CBB77;border: 1px solid #8CBB77;" @click="dialogVisible1 = false" size="mini" round>取 消</el-button>
			  </span>
		</el-dialog>
	</div>
</template>

<script>
	//import '../static/qmsj/css/table.css'
	export default {
		data() {
			return {
				token: '',
				dialogVisible0: false,
				dialogVisible1: false,
				loading2:false,
				item_id:"",
				item_name:'',
				input0:'',
				inss:"",
				tabledate:"",
				pageone:5,
				skjlnum:100,
				curpage:1,
				tanindex:0,


			};
		},
		methods: {
			// 新建项目
			xin_but:function(){
				if(this.input0==""){
					self.$message.error("项目不能为空");
					return
				}
				let self = this;
				$.ajax({
					type: 'post',
					url: process.env.apiUrl + "saas/Contract/add_project",
					dataType: 'json',
					data: {
						token: self.token,
						name:self.input0,
					},
					success: function(data) {
						console.log(data)
						if(data.status==1){
							self.$message({
							  message: data.msg,
							  type: 'success'
							});
							self.dialogVisible0=false
							self.gonggong()
						}else{
							self.$message.error(data.msg);
						}

					},
					error: function() {
						self.$message.error(`请求失败`);
					}
				});
			},
			// 弹出确认删除
			san_del:function(id,name){
				this.dialogVisible1=true
				this.item_id=id
				this.item_name=name
			},
			// 删除项目
			project_del:function(){
				let self = this;
				$.ajax({
					type: 'post',
					url: process.env.apiUrl + "saas/Contract/del_item",
					dataType: 'json',
					data: {
						token: self.token,
						item_id:self.item_id,
					},
					success: function(data) {
						console.log(data)
						if(data.status==1){
							self.$message({
							  message: data.msg,
							  type: 'success'
							});
							self.tanindex=0
							self.dialogVisible1 = false
							self.gonggong()
						}else{
							self.$message.error(data.msg);
						}

					},
					error: function() {
						self.$message.error(`请求失败`);
					}
				});
			},
			// 显示新建教室
			tan:function (i) {
			    if(this.tanindex==i+1){
			        this.tanindex=0
					this.inss=""
			    }else{
			        this.tanindex=i+1
					this.inss=""
			    }
			},
			// 新建教室
			tan_buts:function (id) {
				if(this.inss==""){
					this.$message.error("教室名称不能为空");
					return
				}
				let self = this;
				$.ajax({
					type: 'post',
					url: process.env.apiUrl + "saas/Contract/add_classroom",
					dataType: 'json',
					data: {
						token: self.token,
						item_id:id,
						classroom:self.inss,
					},
					success: function(data) {
						console.log(data)
						if(data.status==1){
							self.$message({
							  message: data.msg,
							  type: 'success'
							});
							self.tanindex=0
							self.gonggong()
						}else{
							self.$message.error(data.msg);
						}

					},
					error: function() {
						self.$message.error(`请求失败`);
					}
				});
			},
			// 删除教室
			jiao_del:function (id) {
				let self = this;
				$.ajax({
					type: 'post',
					url: process.env.apiUrl + "saas/Contract/del_classroom",
					dataType: 'json',
					data: {
						token: self.token,
						classroom_id:id,
					},
					success: function(data) {
						console.log(data)
						if(data.status==1){
							self.$message({
							  message: data.msg,
							  type: 'success'
							});
							self.tanindex=0
							self.gonggong()
						}else{
							self.$message.error(data.msg);
						}

					},
					error: function() {
						self.$message.error(`请求失败`);
					}
				});
			},
			// 跳转
			jump: function(d,he_id) {
				this.$router.push({
				    name:d,
				    query: {
				         he_id:he_id,
				    }
				 });
			},
			// 分页
			fanye: function(i) {
				let self = this;
				self.curpage = i;
				self.gonggong()
			},
			gonggong: function() {
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/Contract/index",
					data: {
						token: self.token,
						p: self.curpage,
						name: self.input5
					},
					beforeSend: function(xhr) {
						self.loading2 = true
					},
					success: function(data) {
						self.loading2 = false
						self.tabledate = data.data;
						self.skjlnum = data.map.count;

					},
					error: function(data) {
						self.dialogVisible2 = false;
						self.$message.error(`请求失败!`);
					}
				});
			},

		},

		mounted: function() {
			let self = this;
			self.token = self.$cookies.get('token');
			$.ajax({
				type: 'post',
				url: process.env.apiUrl + "saas/Contract/index",
				dataType: 'json',
				data: {
					token: self.token
				},
				beforeSend: function(xhr) {
					self.loading2 = true
				},
				success: function(data) {
					console.log(data)
					self.tabledate = data.data;
					self.skjlnum = data.map.count;
					self.curpage = 1;
					self.loading2 = false;

				},
				error: function() {
					self.$message.error(`请求失败`);
					self.loading2 = false
				}
			});
		}
	}
</script>

<style scoped>
	.body {
		padding-left: 30px;
		padding-right: 30px;
		font-size: 14px;
		color: #666;
	}

	ul {
		list-style: none;
	}
	.table>thead>tr{
		border-radius:8px 8px 0 0;
	}
	.table>thead>tr>th:nth-child(1){
		border-radius:8px 0 0 0;
	}
	.table>thead>tr>th:nth-last-child(1){
		border-radius:0 8px 0 0;
	}
	.table>thead>tr>th,.table>tbody>tr>td{
		border: 0;
		padding-top:10px;
		padding-bottom:10px;
	}
	i{
		font-size: 18px;
		color: #666;
		cursor: pointer;
		vertical-align:middle
	}

	.aply span {
		cursor: pointer;
	}

	.aply span:hover {
		color: #8CBB77;
	}

	.aply i:hover {

		color: #8CBB77;
	}

	.prolist {
		height: 40px;
		display: flex;
		display: -webkit-flex;
		justify-content: flex-start;
		align-items: center;
	}
	.buts{
		display: inline-block;
		background: #8CBB77;
		border: none;
		border-radius: 16px;
		padding: 5px 20px;
		font-size: 12px;
		line-height: 1.5;
		color: #fff;
		margin-right: 10px;
		cursor: pointer;
	}
	.task_box1{
		width:100%;
		height: 50px;
		text-align: center;
		line-height: 50px;
	}
	.task_box1 input{
		width:400px;
		height:30px;
		border: 1px solid #E5E5E5;
		border-radius:13px;
		outline: none;
		padding-left:8px;
	}
	.task_box2{
		width:460px;
		margin: auto;
		height: 50px;
		font-weight:500;
		padding-left:60px;
	}
	.tjia{
		text-align: left;
		padding-bottom: 10px;
	}
	.tjia input{
		width:150px;
		height:25px;
		border: 1px solid #E5E5E5;
		border-radius:13px;
		padding-left:8px;
		vertical-align:middle
	}
	.tjia button{
		width: 50px;
		height: 25px;
		line-height: 25px;
		border: 0;
		font-size: 12px;
		border-radius:5px;
		color:#8CBB77;
		background:#f1f1f1;
		vertical-align:middle
	}
	.jiaoshu ul li{float: left;padding-right:25px;padding-bottom: 15px;}
	.operation span{
		cursor: pointer;
	}
	input,textarea,select,a,button:focus {outline: none;}
</style>
<style>
	.rightsearch .el-input__inner {
		border-radius: 15px 0 0 15px;
		border: 1px solid #8CBB77;
	}

	.rightsearch .el-input-group__append {
		border-radius: 0 15px 15px 0;
		overflow: hidden;
		border: 1px solid #8CBB77;

	}


	.tanchuang .el-dialog__header {
		padding: 10px 20px 5px;
		color: #fff;
		background: #8CBB77;
	}

	.tanchuang .el-dialog__headerbtn {
		right: 10px;
		top: 10px;
		color: #fff;
	}

	.tanchuang .el-dialog__headerbtn i {
		color: #fff;
	}

	.jishu .el-input-number__decrease,
	.jishu .el-input-number__increase {
		display: none;
	}

	.zhiweibox .el-checkbox {
		width: 90px;

	}

	.zhiweibox .el-checkbox+.el-checkbox {

		margin-left: 0;
	}

	.table-bottom {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		display: -webkit-flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
	}
</style>



// WEBPACK FOOTER //
// src/pages/xitong/xinjianheyue.vue